import { useEffect } from "react";
import Header from "./Header";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="">
      <Header />

      <div className="bg-gray-900 text-white min-h-screen p-6">
        <div className="w-full mx-auto bg-gray-800 p-8 rounded-lg shadow-lg">
          <h1 className="text-3xl font-bold mb-6 text-center">
            Privacy Policy – Bizecho Tech
          </h1>
          <hr className="font-white w-50 text-center pb-5" />
          <section className="mb-6">
            <h2 className="text-lg font-semibold pb-5">
              Effective Date: 2/7/2025
            </h2>
            <p className="mt-2">
              At Bizecho Tech, we are committed to safeguarding the privacy of
              our users and clients. This Privacy Policy outlines how we
              collect, use, and protect data when businesses use our
              WhatsApp-based chatbot services to engage with their customers.
            </p>
          </section>

          <hr className="font-white w-50 text-center pb-5" />

          <section className="mb-6">
            <h2 className="text-2xl font-semibold">1. Who We Are</h2>

            <div className="mt-2">
              Bizecho Tech is a customer experience platform that enables
              businesses such as automobile companies, hotels, restaurants,
              travel agencies, and rental services to collect structured
              feedback from customers via WhatsApp.
              <p className="mt-2">
                Bizecho is a product owned and operated by Bizecho Tech.
              </p>
              <p className="mt-2">
                <span className="font-bold">Registered Address: </span>
                1st Floor, Building No. 80, Sehdev Market, Civil Lines,
                Jalandhar – 144001, Punjab, India Contact: contact@bizecho.co.in
              </p>
              <p className="mt-2">
                <span className="font-bold">Contact: </span>{" "}
                contact@bizecho.co.in
              </p>
            </div>
          </section>
          <hr className="font-white w-50 text-center pb-5" />

          <section className="mb-6">
            <h2 className="text-2xl font-semibold">2. What Data We Collect</h2>
            <p>
              When a customer interacts with our feedback chatbot (on behalf of
              a business), we may collect the following:
            </p>
            <ul className="list-disc pl-6 mt-2">
              <li>Customer name and mobile number.</li>
              <li>Sales executive’s name (as shared by the business).</li>
              <li>
                Vehicle model, variant, color, or equivalent transaction info .
              </li>
              <li>Date of purchase or service .</li>
              <li>Customer feedback rating and comments .</li>
            </ul>
            <p className="pt-3">
              This data is collected solely to enable feedback collection and
              analysis for the business.
            </p>
          </section>
          <hr className="font-white w-50 text-center pb-5" />

          <section className="mb-6">
            <h2 className="text-2xl font-semibold">3. How We Use the Data</h2>
            <p>The collected data is used to:</p>
            <ul className="list-disc pl-6 mt-2">
              <li>Send structured feedback messages via WhatsApp.</li>
              <li>Provide dashboards and reports to our business clients.</li>
              <li>Improve sales, service, and customer experience.</li>
            </ul>
            <p className="pt-3">
              We do not use this data for advertising or marketing.
            </p>
            <p className="pt-3">
              We do not share or sell customer data to any third parties.
            </p>
          </section>
          <hr className="font-white w-50 text-center pb-5" />

          <section className="mb-6">
            <h2 className="text-2xl font-semibold">
              4. Use of WhatsApp Business API
            </h2>
            <p className="mt-2">
              Bizecho Tech uses Meta’s official WhatsApp Business API to send
              feedback messages on behalf of our clients. All messages use
              pre-approved templates and comply with WhatsApp’s business
              messaging policies.
            </p>
          </section>
          <hr className="font-white w-50 text-center pb-5" />

          <section className="mb-6">
            <h2 className="text-2xl font-semibold">
              5. Data Retention and Control
            </h2>
            <p className="mt-2">
              We store the collected data securely and retain it only as long as
              needed to support the services provided to our clients. <br />
              Customers who wish to delete their data or opt out of
              communication must directly contact the respective business
              (dealer or service provider).
            </p>
          </section>
          <hr className="font-white w-50 text-center pb-5" />

          <section className="mb-6">
            <h2 className="text-2xl font-semibold">6. Security Practices</h2>
            <p className="mt-2">
              We implement strict administrative and technical safeguards to
              protect data from unauthorized access or misuse. Data access is
              restricted to authorized Bizecho Tech personnel and client
              business teams.
            </p>
          </section>
          <hr className="font-white w-50 text-center pb-5" />

          <section className="mb-6">
            <h2 className="text-2xl font-semibold">7. Third-Party Access</h2>
            <p className="mt-2">
              We do not share any data with external marketers, advertisers, or
              analytics companies. Our infrastructure partners (e.g., cloud
              hosting providers) are bound by strict confidentiality and data
              protection agreements.
            </p>
          </section>
          <hr className="font-white w-50 text-center pb-5" />

          <section className="mb-6">
            <h2 className="text-2xl font-semibold">
              8. Dealer Confidentiality & NDAs
            </h2>
            <p className="mt-2">
              Bizecho Tech signs a Non-Disclosure Agreement (NDA) with each of
              its client businesses. These NDAs legally bind us to:
            </p>
            <ul className="list-disc pl-6 mt-2">
              <li>
                Maintain strict confidentiality of all customer-related data .
              </li>
              <li>Not disclose, share, or sell any data to third parties .</li>
              <li>
                Handle all data exclusively within the scope of services agreed
                with the dealer .
              </li>
            </ul>
            <p className="pt-3">
              This further reinforces our commitment to data privacy, business
              ethics, and responsible technology practices. .
            </p>
          </section>
          <hr className="font-white w-50 text-center pb-5" />

          <section className="mb-6">
            <h2 className="text-2xl font-semibold">
              9. Updates to This Policy
            </h2>
            <p className="mt-2">
              We may update this Privacy Policy from time to time. Any changes
              will be reflected on this page with a revised &quot;Effective
              Date.&quot;
            </p>
          </section>
          <hr className="font-white w-50 text-center pb-5" />

          <section className="mb-6">
            <h2 className="text-2xl font-semibold">10. Contact Us</h2>
            <p className="mt-2">
              If you have any questions, please contact us at:
            </p>
            <p className="mt-2">
              Email:{" "}
              <a href="mailto:contact@bizecho.co.in" className="text-blue-400">
                contact@bizecho.co.in
              </a>
            </p>
            <p className="mt-2">
              <span className="font-bold">Address: </span> Bizecho Tech, 1st
              Floor, Building No. 80, Sehdev Market, Civil Lines, Jalandhar –
              144001, Punjab, India
            </p>
            <p className="mt-2">
              Website:{" "}
              <a href="https://bizecho.co.in/" className="text-blue-400">
                https://bizecho.co.in/
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
